<footer class="landing-footer">
    <div class="footer-container">
        <div class="footer-content">
            <div class="footer-brand">
                <img src="assets/logo_dark_theme.png" alt="Radio Ads Direct" class="footer-logo" />
                <p class="footer-copyright">Copyright © {{ currentYear }} Radio Ads Direct</p>
            </div>

            <div class="footer-sections">
                <div *ngFor="let section of footerSections" class="footer-section">
                    <h3 class="footer-section-title">{{ section.title }}</h3>
                    <ul class="footer-links">
                        <li *ngFor="let link of section.links">
                            <a [href]="link.url">{{ link.label }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="footer-contact">
                <h3 class="footer-section-title">Contact</h3>
            </div>
        </div>
    </div>
</footer>